const courseFields = [
  {
    name: "title",
    label: "Course Title",
    type: "text",
    placeholder: "Type course title",
  },
  {
    name: "duration",
    label: "Duration",
    type: "text",
    placeholder: "Course Duration",
  },
  {
    name: "price",
    label: "Price",
    type: "number",
    placeholder: "Course Price",
  },
  {
    name: "level",
    label: "Course Level",
    type: "text",
    placeholder: "Course Level",
  },
  {
    name: "capacity",
    label: "Course Capacity",
    type: "number",
    placeholder: "Course Capacity",
  },
  {
    name: "category_id",
    label: "Course Category",
    type: "select",
    options: [],
    placeholder: "Select Category",
  },
  {
    name: "instructor_id",
    label: "Course Instructor",
    type: "select",
    options: [],
    placeholder: "Select Instructor Account",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Course Description",
  },
  { name: "status", label: "Course Status", type: "toggle" },
  {
    name: "requires_placement_test",
    label: "Requires Placement Test",
    type: "toggle",
    defaultValue: false,
  },
  { name: "image_url", label: "Course Image", type: "file" },
];

export default courseFields;
